// slick slider
import "../../node_modules/slick-carousel-latest/slick/slick.scss";

// style
import "../scss/styles.scss";

import "./scripts/global/header.js";
import "./scripts/global/cookie-consent.js";